<template>
    <div :class="config.col + ' mb-2'">
        <div class="d-flex justify-content-between align-items-center mb-1">
            <label class="form-label fw-medium text-dark mb-0">{{ config.label }}</label>
            <!-- Badge "Đã quét" -->
            <span
                v-if="isScanned"
                class="badge badge-success font-weight-normal"
                style="font-size: 11px"
            >
                <i class="fas fa-check-circle mr-1"></i>
                Đã quét
            </span>
        </div>

        <ValidationProvider
            v-slot="{ errors }"
            :name="config.label"
            :rules="config.rules"
        >
            <!-- 1. Text Input thông thường -->
            <input
                v-if="config.type === 'text'"
                type="text"
                :value="value"
                :maxlength="config.maxlength"
                :placeholder="config.placeholder"
                class="form-control"
                :class="{ 'border-success': isScanned }"
                @input="handleInput($event.target.value)"
            />

            <!-- 2. Textarea (Quê quán, Nơi thường trú) -->
            <textarea
                v-else-if="config.type === 'textarea'"
                :value="value"
                rows="2"
                :placeholder="config.placeholder"
                class="form-control"
                :class="{ 'border-success': isScanned }"
                @input="handleInput($event.target.value)"
            ></textarea>

            <!-- 3. Date Picker (Ngày sinh, Ngày cấp, Có giá trị đến) -->
            <el-date-picker
                v-else-if="config.type === 'date'"
                :value="value"
                type="date"
                :placeholder="config.placeholder"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                :class="{ 'border-success': isScanned }"
                @input="handleInput"
            />

            <!-- 4. Select (Giới tính) -->
            <el-select
                v-else-if="config.type === 'select'"
                :value="value"
                placeholder="Chọn giới tính"
                style="width: 100%"
                :class="{ 'border-success': isScanned }"
                @change="handleInput"
            >
                <el-option
                    v-for="opt in config.options"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                />
            </el-select>

            <!-- Báo lỗi Validation -->
            <div class="text-danger small mt-1">
                {{ errors[0] }}
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
export default {
    name: "OcrFormField",
    props: {
        config: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number],
            default: "",
        },
        isScanned: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleInput(val) {
            this.$emit("input", val);
            this.$emit("edited");
        },
    },
};
</script>

